import * as queryString from 'query-string';
import generateActions from './baseAction';
import API from '../api';
import * as actions from '../constants';
import PAGINATE from '../../data/paginate';

const {
  showError,
  clearErrors,
  requestGetNotes,
  receiveGetNotes,
  getNote,
  addNote,
  updateNote,
  removeNote,
} = generateActions('note', 'notes');

interface NoteOptions {
  author?: number;
  assignee?: number;
  type?: string;
  id?: number;
  resolveable?: boolean;
  unresolved?: boolean;
  page?: number;
  max?: number;
}

/**
 * Fetch a list of notes
 * @param options
 */
const getNotes = (options: NoteOptions = {}) => (dispatch) => {
  dispatch(requestGetNotes());
  if (!options.page) {
    options.page = 0;
  }
  options.max = PAGINATE.notes.MAX;
  return API.request(`/notes?${queryString.stringify(options)}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetNotes(response.error, response.data, new Date()));
      return response;
    });
};

/**
 * Assign a user to a note
 * @param id Note ID
 * @param userId User ID
 */
const assignUser = (id, userId) => (dispatch) => {
  dispatch({ type: actions.REQUEST_ASSIGN_NOTE });
  return API.request(`/notes/${id}/assigned`, 'POST', { user_id: userId })
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_ASSIGN_NOTE, ...response });
      return response;
    });
};

/**
 * Unassign a user from a note
 * @param id Note ID
 * @param userId User ID
 */
const unassignUser = (id, userId) => (dispatch) => {
  dispatch({ type: actions.REQUEST_UNASSIGN_NOTE });
  return API.request(`/notes/${id}/assigned`, 'DELETE', { user_id: userId })
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_UNASSIGN_NOTE, ...response });
      return response;
    });
};

export {
  showError,
  clearErrors,
  getNotes,
  getNote,
  addNote,
  removeNote,
  updateNote,
  assignUser,
  unassignUser,
};
